<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  {{question}}
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">No, wait</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</div>